import uuid from 'uuid/v4';

// eslint-disable-next-line import/prefer-default-export
export const makeSlideData = (custom = {}) => ({
  id: uuid(),
  caption: '',
  positive: true,
  ...custom,
});
